import * as React from 'react';
import { useState,useEffect,useContext,useRef } from 'react';
import Table from 'react-bootstrap/Table';
import Pagination from '@mui/material/Pagination';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import Stack from '@mui/material/Stack';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Alert from '@mui/material/Alert'
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-bootstrap/Modal';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import {useParams , useLocation, useSearchParams, useNavigate} from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import BreadcrumbsWrapper from '../../components/breadcrumbs'

function MyVerticallyCenteredModal({ show, onHide, authToken, onCustomerAdd }) {
  const [searchFields, setSearchFields] = useState({
    title: '',
    forename: '',
    surname: '',
    email: '',
    phone_number: ''
  });
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);  
  const debounceRef = useRef();
   

  const fetchCustomerSearch = async () => {
    const isEmpty = Object.values(searchFields).every(v => !v);
    if (isEmpty) {
      setSearchResults([]);
      return;
    }

    try {
      setLoading(true);
      const res = await postRequest('private/leadsCustomerList', searchFields, authToken);
      setSearchResults(res?.data || []);
    } catch (err) {
      console.error('Error fetching search:', err);
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(fetchCustomerSearch, 400);
    return () => clearTimeout(debounceRef.current);
  }, [searchFields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchFields((prev) => ({ ...prev, [name]: value }));
  };



  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Customers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className='m-0'>
          {['title', 'forename', 'surname', 'email', 'phone_number'].map((field, idx) => (
            <Col xs={field === 'email' || field === 'phone_number' ? 6 : 4} key={idx}>
              <Box sx={{ '& > :not(style)': { m: 1, width: '100%' } }}>
                <TextField
                  label={field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')}
                  name={field}
                  value={searchFields[field]}
                  onChange={handleChange}
                  variant="outlined"
                  type={field === 'email' ? 'email' : field === 'phone_number' ? 'tel' : 'text'}
                />
              </Box>
            </Col>
          ))}
        </Row>

        <Row className='mt-4'>
          <Col>
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Add</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="4" className='text-center'>Loading...</td></tr>
                ) : searchResults.length > 0 ? (
                  searchResults.map((customer) => (
                    <tr key={customer._id}>
                      <td>{customer.title} {customer.forename} {customer.surname}</td>
                      <td>{customer.email}</td>
                      <td>{customer.phone_number}</td>
                      <td>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            onCustomerAdd(customer);
                            onHide();
                          }}
                        >
                          Add
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="4" className='text-center'>No customers found</td></tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}


export const GeneralEnquiries = () =>{

  const [customerList, setCustomerList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
   const [editorData, setEditorData] = useState('');
    const [modalShow, setModalShow] = React.useState(false);
     const [customerError, setCustomerError] = useState(false);
       const [selectedCustomers, setSelectedCustomers] = useState([]);
         const [groupCodes, setGroupCodes] = useState([]);
            const [customerData, setCustomerData] = useState(null);
            const [lenderPanels, setLenderPanels] = useState([]);
     const { customerId, slug } = useParams();
     const location = useLocation()
        const productId = location.state?.productId;

  // Get customerId from URL query params
  const [searchParams] = useSearchParams();
  const customerIdFromUrl = searchParams.get('customerId');

            const slugToTitle = (slug) => {
          return slug
            .replace(/-/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase());
        };
        
          const readableTitle = slugToTitle(slug || '');



  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();


   const {
      handleSubmit,
      control,
      reset,
      formState: { errors },
    } = useForm({
      defaultValues: {
        group_code: '',
        details: '',
        override_date: null,
        lender_panel_id: '',
      },
      mode: 'onTouched',
    });



    
   const fetchGroupCodes = async () => {
      try {
        const res = await postRequest('private/getGroupCodeList');
        if (res?.status === 200 && Array.isArray(res?.data)) {
          setGroupCodes(res.data);
        }
      } catch (err) {
        console.error("Failed to fetch group codes:", err);
      }
    };

    // Fetch active lender panels
    const fetchActiveLenderPanels = async () => {
      try {
        const response = await postRequest('private/getActiveLenderPanels', {}, authCtx.token);
        if (response?.status === 200 && response?.data) {
          setLenderPanels(response.data);
        }
      } catch (error) {
        console.error('Error fetching lender panels:', error);
      }
    };


    
      const fetchCustomerDetails = async (id) => {
        try {
          const response = await postRequest(`private/getCustomerIndividualData/${id}`);
          if (response?.status === 200 && response?.data) {
            setCustomerData(response.data);
          }
        } catch (err) {
          console.error('Error fetching customer details', err);
        }
      };


      useEffect(() => {
      fetchGroupCodes();
      if (customerId) fetchCustomerDetails(customerId);
    }, [customerId]);

    // Fetch active lender panels on mount
    useEffect(() => {
      fetchActiveLenderPanels();
    }, [authCtx.token]);

    // Fetch initial customer from URL and add to selectedCustomers
    useEffect(() => {
      const fetchInitialCustomer = async () => {
        if (customerIdFromUrl && authCtx.token && selectedCustomers.length === 0) {
          console.log('🔍 Fetching initial customer from URL:', customerIdFromUrl);
          try {
            const customerRes = await postRequest(`private/getCustomerIndividualData/${customerIdFromUrl}`, {}, authCtx.token);
            if (customerRes?.data) {
              console.log('✅ Fetched initial customer:', customerRes.data);
              setSelectedCustomers([customerRes.data]);
              setCustomerError(false);
            }
          } catch (err) {
            console.error('❌ Error fetching initial customer:', err);
          }
        }
      };

      fetchInitialCustomer();
    }, [customerIdFromUrl, authCtx.token]);


  

    const handleCustomerAdd = (customer) => {
    if (!selectedCustomers.some(c => c._id === customer._id)) {
      setSelectedCustomers(prev => [...prev, customer]);
      setCustomerError(false); // ✅ reset error
    }
  };



  const handlePageChange = (event, value) => {
    setPage(value);
  };


    const onSubmit = async (formData) => {

      console.log(formData , 'formdata....12345678' , editorData , 'editorData')
     
      if (selectedCustomers.length === 0) {
        setCustomerError(true);
        return;
      }
  
      const created_id = localStorage.getItem('id')
  
      const payload = {
        ...formData,
        details: editorData,
        product_id:productId,
        created_id:created_id,
        customer_ids: selectedCustomers.map(c => c._id),
          override_date: formData.override_date?.toISOString(),
        lender_panel_id: formData.lender_panel_id || null,
      };
  
      try {
        const res = await postRequest('private/createLeads', payload);
        if (res?.status == 'success') {
          Swal.fire('Success', 'Leads created successfully!', 'success').then(() => {
            navigate('/leads');
          });
          reset();
          setSelectedCustomers([]);
        } else {
          Swal.fire('Error', res?.message || 'Failed to create leads', 'error');
        }
      } catch (err) {
        Swal.fire('Error', err?.message || 'Something went wrong', 'error');
      }
    };

  return (
    <>
     <BreadcrumbsWrapper
           items={[
           { label: 'Dashboard', path: '/dashboard' },
            { label: 'Customers', path: '/customers' },
            { label: 'General Enquiry', path: '' },
              ]}
                />
               <br></br>
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Create {readableTitle}
             <small className='color-grey'> {customerData ? `${customerData.forename || ''} ${customerData.surname || ''}` : ''}</small>
         </h1>
       
      </div>

      {/* Search Form */}
      <div className='page-top-formview mb-3'>
       <Paper elevation={3} sx={{ p: 4 }}>
       <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
                 <Col xs={6}>
                   <h5>Group Code</h5>
                   <Controller
                     name="group_code"
                     control={control}
                     rules={{ required: 'Group Code is required' }}
                     render={({ field }) => (
                       <FormControl fullWidth sx={{ my: 1 }} error={!!errors.group_code}>
                         <InputLabel>Group Code</InputLabel>
                         <Select {...field} label="Group Code">
                           {groupCodes.map((item) => (
                             <MenuItem key={item.code} value={item._id}>
                               {item.name} ({item.code})
                             </MenuItem>
                           ))}
                         </Select>
                         {errors.group_code && (
                           <p style={{ color: 'red', fontSize: '0.8rem' }}>{errors.group_code.message}</p>
                         )}
                       </FormControl>
                     )}
                   />
                 </Col>

                 
                       <Col xs={6}>
  <h5>Override Date</h5>
  <Form.Group as={Col} controlId="overrideDate">
    <Controller
      name="override_date"
      control={control}
      render={({ field }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              label="Override Date"
              sx={{ width: '100%' }}
              {...field}
              value={field.value || null}
              onChange={(date) => field.onChange(date)}
            />
          </DemoContainer>
        </LocalizationProvider>
      )}
    />
  </Form.Group>
                        </Col>


               </Row>

          {/* Lender Panel Section */}
          <Row className="mt-3">
            <Col xs={12}>
              <h5>Lender Panel</h5>
            </Col>
            <Col xs={12} md={6}>
              <Controller
                name="lender_panel_id"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth sx={{ my: 1 }}>
                    <Select
                      {...field}
                      displayEmpty
                      sx={{ backgroundColor: 'white' }}
                    >
                      <MenuItem value="">
                        <em>Select Lender Panel (Optional)</em>
                      </MenuItem>
                      {lenderPanels.map((panel) => (
                        <MenuItem key={panel._id} value={panel._id}>
                          {panel.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            </Col>
          </Row>

             <Row className="mb-3">
  <h5>Details</h5>
  <div style={{ width: '100%' }}>
    <CKEditor
      editor={ClassicEditor}
      data={editorData}
      config={{ placeholder: 'Write some enquiry here...' }}
      onReady={(editor) => {
        const editableElement = editor.ui.view.editable.element;
        editableElement.style.minHeight = "400px";
        editableElement.style.height = "400px";
        editableElement.style.overflow = "auto";
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        setEditorData(data);
      }}
      onFocus={(event, editor) => {
        const editableElement = editor.ui.view.editable.element;
        editableElement.style.minHeight = "400px";
        editableElement.style.height = "400px";
        editableElement.style.overflow = "auto";
      }}
      onBlur={(event, editor) => {
        const editableElement = editor.ui.view.editable.element;
        editableElement.style.minHeight = "400px";
        editableElement.style.height = "400px";
        editableElement.style.overflow = "auto";
      }}
    />
  </div>
</Row>




          <Row className="mb-3 mt-3">
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
              Customers
            </Typography>
            {customerError && (
              <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                Please select at least one customer.
              </Alert>
            )}
            <Box sx={{ mb: 3 }}>
              {selectedCustomers.map((customer) => (
                <Box
                  key={customer._id}
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    mb: 2,
                    p: 1.5,
                    border: '1px solid #e0e0e0',
                    borderRadius: 1,
                    backgroundColor: '#f9f9f9'
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {customer.title} {customer.forename} {customer.surname}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Typography variant="body2" sx={{ color: '#666', display: 'flex', alignItems: 'center' }}>
                        📧 {customer.email}
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666', display: 'flex', alignItems: 'center' }}>
                        📞 {customer.phone_number}
                      </Typography>
                    </Box>
                  </Box>
                  <Button
                    size="small"
                    onClick={() =>
                      setSelectedCustomers(prev =>
                        prev.filter(c => c._id !== customer._id)
                      )
                    }
                    sx={{
                      minWidth: 'auto',
                      color: '#d32f2f',
                      '&:hover': {
                        backgroundColor: '#ffebee'
                      }
                    }}
                  >
                    ✕
                  </Button>
                </Box>
              ))}
              <Button
                variant="text"
                startIcon={<AddIcon />}
                onClick={() => setModalShow(true)}
                sx={{ color: '#6f42c1', textTransform: 'none' }}
              >
                Add Customer
              </Button>
            </Box>
            <MyVerticallyCenteredModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              authToken={authCtx.token}
              onCustomerAdd={handleCustomerAdd}
            />
          </Row>

            <Row>
                      <Form.Group as={Col}>
                        <FormControl fullWidth sx={{ my: 1 }}>
                          <Stack spacing={2} direction="row">
                            <Button variant="contained" type="submit" className='red-bg red-button text-capitalize h-56'>Submit</Button>
                          </Stack>
                        </FormControl>
                      </Form.Group>
                    </Row>

                    </Form>
       </Paper>
      </div>

      {/* Table View */}
      <div>
        

        {/* Pagination */}
        {customerList.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
              size="medium"
              sx={{
                '& .Mui-selected': {
                  backgroundColor: '#bb0000 !important',
                  color: '#fff !important',
                },
                '& .MuiPaginationItem-root': {
                  color: '#bb0000',
                  borderColor: '#bb0000',
                },
              }}
            />
          </div>
        )}
      </div>
    </>
  );
}
